/**
 * 龙舟教学页面组件
 * 莫兰迪配色风格的专业教学设计页面
 */
<template>
  <div class="teaching-page">
    <!-- 返回按钮 -->


    <!-- 主容器 -->
    <div class="teaching-container">
      <!-- 左侧教学设计模块 -->
      <div class="teaching-design">
        <div class="design-header">
          <h1>教学设计</h1>
          <p class="design-subtitle">龙舟项目式教学方案</p>
        </div>

        <ul class="design-list">
          <li 
            v-for="(item, index) in teachingDesignItems" 
            :key="index"
            class="design-item fade-in"
            :style="{ animationDelay: `${(index + 1) * 0.1}s` }"
            @click="onItemClick"
          >
            <h3>
              <span class="design-number">{{ item.number }}</span>
              {{ item.title }}
            </h3>
            <p>{{ item.description }}</p>
          </li>
        </ul>
      </div>

      <!-- 右侧标题和图片区域 -->
      <div class="teaching-showcase">
        <div class="showcase-card">
          <h2 class="showcase-title">龙舟+项目式教学</h2>
          
          <div class="teaching-tags">
            <span v-for="tag in teachingTags" :key="tag" class="teaching-tag">
              {{ tag }}
            </span>
          </div>
          
          <!-- 图片展示区域 -->
          <div class="image-gallery">
            <!-- 主图片 -->
            <div 
              class="gallery-image main-image" 
              :style="{ backgroundImage: `url('${mainImage}')` }"
            ></div>
            
            <!-- 其他图片 -->
            <div 
              v-for="(image, index) in galleryImages" 
              :key="index"
              class="gallery-image" 
              :style="{ backgroundImage: `url('${image}')` }"
            ></div>
          </div>
          
          <p class="showcase-description">
            通过项目式教学方法，让学生在实践中深入了解龙舟文化的历史传承与现代价值，培养文化自信与团队协作精神。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LongzhouTeachingPage',
  data() {
    return {
      // 教学设计项目列表
      teachingDesignItems: [
        {
          number: '一',
          title: '课标分析',
          description: '基于新课程标准，通过龙舟文化项目培养学生的文化认同感、团队协作能力和创新实践能力，落实立德树人根本任务。'
        },
        {
          number: '二',
          title: '教材分析',
          description: '龙舟文化作为中华优秀传统文化的重要组成部分，具有丰富的历史内涵和教育价值，适合开展跨学科综合实践活动。'
        },
        {
          number: '三',
          title: '学情分析',
          description: '学生对传统文化兴趣浓厚，具备一定的合作学习能力，但缺乏对龙舟文化的深入了解和实践体验。'
        },
        {
          number: '四',
          title: '教学目标',
          description: '通过项目式学习，使学生深入了解龙舟文化内涵，提升文化自信，培养团队协作精神和创新实践能力。'
        },
        {
          number: '五',
          title: '教学重难点',
          description: '重点：龙舟文化的历史传承与现代价值；难点：项目任务的设计与实施，团队协作能力的培养。'
        },
        {
          number: '六',
          title: '教学思路',
          description: '采用项目驱动的教学模式，通过调研、设计、制作、展示等环节，让学生在实践中学习，在体验中感悟。'
        },
        {
          number: '七',
          title: '教学准备',
          description: '准备龙舟文化资料、制作工具材料、多媒体设备等，为项目实施提供充分的资源保障。'
        },
        {
          number: '八',
          title: '教学过程',
          description: '分为项目启动、任务分解、协作实施、成果展示、总结反思五个阶段，循序渐进地推进项目学习。'
        },
        {
          number: '九',
          title: '板书设计',
          description: '以思维导图形式呈现龙舟文化的核心要素，突出项目学习的关键节点和重要概念。'
        },
        {
          number: '十',
          title: '教学总结或反思',
          description: '反思项目实施效果，总结成功经验和不足之处，为后续教学改进提供参考依据。'
        }
      ],
      // 教学标签
      teachingTags: ['项目式学习', '传统文化', '团队协作'],
      // 主图片
      mainImage: '/img/龙舟.jpg',
      // 图片库
      galleryImages: [
        '/img/22.jpg',
        '/img/33.jpg'
      ]
    }
  },
  mounted() {
    // 页面加载完成后的操作
    this.initPage();
    this.initAnimations();
  },
  methods: {
    /**
     * 初始化页面
     */
    initPage() {
      // 设置页面标题
      document.title = '龙舟项目式教学 - 中华非遗';
      
      // 滚动到顶部
      window.scrollTo(0, 0);
    },

    /**
     * 初始化动画效果
     */
    initAnimations() {
      // 使用 Intersection Observer 实现滚动动画
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      // 观察所有教学设计项目
      const items = document.querySelectorAll('.design-item');
      items.forEach(item => {
        observer.observe(item);
      });
    },

    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * 设计项目点击效果
     */
    onItemClick(event) {
      const item = event.currentTarget;
      item.style.transform = 'translateX(12px) scale(1.02)';
      setTimeout(() => {
        item.style.transform = 'translateX(8px)';
      }, 200);
    }
  }
}
</script>

<style scoped>
/**
 * 莫兰迪配色风格的专业教学设计页面
 */

/* 莫兰迪配色变量 */

/* 页面主体样式 */
.teaching-page {
  background: linear-gradient(135deg, #f9f7f4 0%, #f5f1eb 100%);
  min-height: 100vh;
  font-family: 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, sans-serif;
  padding-top: 80px; /* 为导航栏留出空间 */
}

/* 主容器布局 */
.teaching-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 40px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

/* 左侧教学设计模块 */
.teaching-design {
  background: white;
  border-radius: 20px;
  padding: 50px;
  box-shadow: 0 15px 35px rgba(107, 107, 107, 0.08);
  border: 1px solid #e8ddd4;
}

.design-header {
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 2px solid #e8ddd4;
}

.design-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #6b6b6b;
  margin-bottom: 15px;
  position: relative;
}

.design-header h1::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #9caf88, #8a9ba8);
  border-radius: 2px;
}

.design-subtitle {
  font-size: 1.2rem;
  color: #8a9ba8;
  font-weight: 500;
}

/* 教学设计列表 */
.design-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.design-item {
  background: #f9f7f4;
  border-radius: 15px;
  margin-bottom: 20px;
  padding: 25px 30px;
  transition: all 0.3s ease;
  border-left: 5px solid #9caf88;
  position: relative;
  overflow: hidden;
}

.design-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, transparent 0%, rgba(156, 175, 136, 0.03) 100%);
  pointer-events: none;
}

.design-item:hover {
  transform: translateX(8px);
  box-shadow: 0 8px 25px rgba(156, 175, 136, 0.15);
  border-left-color: #8a9ba8;
}

.design-item h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #6b6b6b;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.design-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: linear-gradient(135deg, #9caf88, #8a9ba8);
  color: white;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: 700;
  flex-shrink: 0;
}

.design-item p {
  color: #6b6b6b;
  line-height: 1.7;
  font-size: 1rem;
  margin: 0;
  opacity: 0.8;
}

/* 右侧标题和图片区域 */
.teaching-showcase {
  position: sticky;
  top: 120px; /* 调整sticky位置，考虑导航栏高度 */
}

.showcase-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(107, 107, 107, 0.08);
  border: 1px solid #e8ddd4;
  text-align: center;
}

.showcase-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #6b6b6b;
  margin-bottom: 30px;
  position: relative;
  line-height: 1.3;
}

.showcase-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #9caf88, #8a9ba8);
  border-radius: 2px;
}

/* 教学标签 */
.teaching-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-bottom: 25px;
}

.teaching-tag {
  background: linear-gradient(135deg, #9caf88, #8a9ba8);
  color: white;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* 图片网格布局 */
.image-gallery {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 30px;
}

.gallery-image {
  width: 100%;
  height: 180px;
  border-radius: 15px;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.gallery-image:hover {
  transform: scale(1.05);
}

.gallery-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(156, 175, 136, 0.1) 0%, rgba(138, 155, 168, 0.1) 100%);
}

/* 主图片样式 */
.main-image {
  grid-column: 1 / -1;
  height: 250px;
  margin-bottom: 15px;
}

.showcase-description {
  color: var(--morandi-charcoal);
  line-height: 1.6;
  font-size: 1rem;
  margin: 0;
}

/* 返回按钮 */
.back-button {
  position: fixed;
  top: 90px; /* 调整位置避免与导航栏重叠 */
  left: 30px;
  background: var(--morandi-sage);
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 4px 15px rgba(156, 175, 136, 0.3);
}

.back-button:hover {
  background: var(--morandi-blue);
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(138, 155, 168, 0.4);
}

/* 动画效果 */
.fade-in {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s ease forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .teaching-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .teaching-showcase {
    position: static;
    order: -1;
  }
  
  .teaching-design {
    padding: 30px;
  }
}

@media (max-width: 768px) {
  .teaching-page {
    padding-top: 70px; /* 移动端导航栏高度稍小 */
  }

  .teaching-container {
    padding: 20px 15px;
  }
  
  .design-header h1 {
    font-size: 2rem;
  }
  
  .showcase-title {
    font-size: 1.8rem;
  }
  
  .design-item {
    padding: 20px;
  }
  
  .showcase-card {
    padding: 25px;
  }

  .back-button {
    top: 80px; /* 移动端也要考虑导航栏 */
    left: 20px;
    width: 45px;
    height: 45px;
  }

  .teaching-showcase {
    top: 100px; /* 移动端sticky位置调整 */
  }
}
</style> 